import { render } from "./AddNoteCard.vue?vue&type=template&id=65575814&scoped=true"
import script from "./AddNoteCard.vue?vue&type=script&lang=js"
export * from "./AddNoteCard.vue?vue&type=script&lang=js"

import "./AddNoteCard.vue?vue&type=style&index=0&id=65575814&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65575814"]])

export default __exports__